import { lazy } from 'react';

export const InitialPageLazy = lazy(() => import('./initial-page'));
